import { LOCALES } from 'i18n/locales';

export const mapInfoIntl = {
    [LOCALES.ENGLISH]: {
        'mapInfo.scale': 'Scale',
        'mapInfo.center': 'Center',
        'mapInfo.coordinates': 'Coordinates'
    },
    [LOCALES.WELSH]: {
        'mapInfo.scale': 'Graddfa',
        'mapInfo.center': 'Canol',
        'mapInfo.coordinates': 'Cyfesurynnau'
    }
};
